/** @module csi/dgrid/FooterMixin */
define([
	'dojo/_base/declare',
	'dojo/_base/lang',
	'dojo/dom-construct',
	'dojo/dom-style',
	"csi/_base/underscore",
	"csi/html"
], function (declare,lang,domConstruct,domStyle,_,html) {
	
	return declare(null, {
		// summary:
		//	  A mixin for dgrid components which renders
		//	  a row with summary information (e.g. totals).
 
		// Show the footer area, which will hold the summary row
		showFooter: true,
		
		// Array of columns data, same format as single row data, used to render columns in footer
		//summary = [];
 
		buildRendering: function () {
			this.inherited(arguments);

			var areaNode = this.summaryAreaNode =
				domConstruct.create('div', {
					className: 'dgrid-summary-row',
					role: 'row',
					style: { overflow: 'hidden' }
				}, this.footerNode);

			var scrollWidth = domStyle.get(this.headerScrollNode, 'width');
			domStyle.set(areaNode,'padding-right', scrollWidth + 'px');
 

			// Keep horizontal alignment in sync
			this.on('scroll', lang.hitch(this, function () {
				areaNode.scrollLeft = this.getScrollPosition().x;
			}));
 
			// Process any initially-passed summary data
			if (this.summary) {
				this._setSummary(this.summary);
			}
		},
 
		_updateColumns: function () {
			this.inherited(arguments);
			if (this.summary) {
				// Re-render summary row for existing data,
				// based on new structure
				this._setSummary(this.summary);
			}
		},
 
		renderSummaryCell: function (item, cell, column) {
			// summary:
			//	  Simple method which outputs data for each
			//	  requested column into a text node in the
			//	  passed cell element.  Honors columns'
			//	  get, formatter, and renderCell functions.
			//	  renderCell is called with an extra flag,
			//	  so custom implementations can react to it.
 
			var value = item[column.field] || '';
			cell.appendChild(document.createTextNode(value));
		},
 
		/**
		 * Check columns if their content width is above default width, if so - update column width
		 * Function will only work if ColumnResizer extension is added to the grid, otherwise do nothing
		 * @param {Object} node
		 */
		_checkColumnsWidth: function(node){
			if (this.resizeColumnWidth){ // This function defined in ColumnResizer dgrid extension
				var cells = $(node).find('.dgrid-cell');
				_.each(cells, function(cell){
					var width = html.getElementSize(cell, 'csi-slicer-grid-container','dgrid-summary-row').width;
					width = Math.min(width, 200);
					if (width > 100){ // Default column width = 120, padding = 10+10
						this.resizeColumnWidth(cell.columnId, width + 20);
					}
				}, this);
			}
		},
		
		_setSummary: function (data) {
			// summary:
			//	  Given an object whose keys map to column IDs,
			//	  updates the cells in the footer row with the
			//	  provided data.
			var tableNode = this.summaryTableNode;
 
			this.summary = data;
 
			// Remove any previously-rendered summary row
			if (tableNode) {
				domConstruct.destroy(tableNode);
			}
 
			// Render summary row
			// Call renderSummaryCell for each cell
			tableNode = this.summaryTableNode =
				this.createRowCells('td',
					lang.hitch(this, 'renderSummaryCell', data));
			this.summaryAreaNode.appendChild(tableNode);
			this._checkColumnsWidth(tableNode);

			// Force resize processing,
			// in case summary row's height changed
			if (this._started) {
				this.resize();
			}
		}
	});
});